import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ParkingSite } from '../models/parkingsite.model';

@Injectable({
  providedIn: 'root'
})
export class ParkingJobService {
  hostPath: string = JSON.parse(environment.IDENTITY);
  parkingJobPath = 'Shuttlebuss/Shuttlebuss.Service/parkingjob';

  constructor(private http: HttpClient) {}

  public getParkingSite(parkingId: string): Observable<ParkingSite> {
    const URL = `${this.hostPath}${this.parkingJobPath}/parkingsite/${parkingId}`;
    return this.http.get<ParkingSite>(URL).pipe(
      map(parkingSiteVM => {
        return parkingSiteVM;
      }), 
      catchError(this.handleError)
    );
  }
  public getParkingSiteFromTo(parkingId: string, parkingFrom: string, parkingTo: string): Observable<ParkingSite> {
    const URL = `${this.hostPath}${this.parkingJobPath}/parkingsite/${parkingId}/${parkingFrom}/${parkingTo}`;
    return this.http.get<ParkingSite>(URL).pipe(
      map(parkingSiteVM => {
        return parkingSiteVM;
      }), 
      catchError(this.handleError)
    );
  }

  public getParkingSiteCheckin(parkingId: string): Observable<ParkingSite> {
    const URL = `${this.hostPath}${this.parkingJobPath}/parkingsitecheckin/${parkingId}`;
    return this.http.get<ParkingSite>(URL).pipe(
      map(parkingSiteVM => {
        return parkingSiteVM;
      }), 
      catchError(this.handleError)
    );
  }

  public getParkingSiteCheckinFromTo(parkingId: string, parkingFrom: string, parkingTo: string): Observable<ParkingSite> {
    const URL = `${this.hostPath}${this.parkingJobPath}/parkingsitecheckin/${parkingId}/${parkingFrom}/${parkingTo}`;
    return this.http.get<ParkingSite>(URL).pipe(
      map(parkingSiteVM => {
        return parkingSiteVM;
      }), 
      catchError(this.handleError)
    );
  }

  private handleError(error: Response | any) {
    const errMsg = error.message
      ? error.message
      : error.status
      ? `${error.status} - ${error.statusText}`
      : 'Server error';
    console.error(`checkoutService.handleError ${errMsg}`);
    return throwError(error);
  }
}
